import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const isMfDomain = typeof window !== 'undefined' && window.location.hostname.includes('mfrealstate');

// Rola pro topo quando uma rota do MF Real Estate muda (home -> imoveis -> imovel).
// Evita o comportamento default do browser de manter o scroll anterior, que fica
// esquisito ao navegar de uma listagem longa pra um detalhe. So ativa nas rotas
// MF pra nao interferir em outras partes do app.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const isMfRoute = isMfDomain || pathname.startsWith('/mf-real-state');
    if (!isMfRoute) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}
